import { Component, OnInit, inject } from "@angular/core";
import { PermissionService } from "src/app/services/permission.service";

@Component({
    selector: "app-planung-api-navigation",
    templateUrl: "./planung-api-navigation.component.html",
    styleUrls: ["./planung-api-navigation.component.css"],
    standalone: false
})
export class PlanungApiNavigationComponent implements OnInit {
  perms = inject(PermissionService);


  public navItems = [];

  ngOnInit() {
    this.navItems.push({
      text: $localize`:@@PlanungAPI_SubModule_Overview:Overview`,
      routerLink: "uebersicht",
    });
    this.navItems.push({
      text: $localize`:@@PlanungAPI_SubModule_Tasks:Tasks`,
      routerLink: "aufgaben",
    });
    this.navItems.push({
      text: $localize`:@@PlanungAPI_SubModule_Reports:Reports`,
      routerLink: "auswertungen",
    });
    if (this.perms.UserCan_Administration_CanSeeExperimentalFeatures) {
      this.navItems.push({
        text: $localize`:@@PlanungAPI_SubModule_RoutePlanning:Route Planning`,
        routerLink: "routen",
      });
    }
    // this.navItems.push({
    //   text: $localize`:@@PlanungAPI_SubModule_Resources:Employees / Groups`,
    //   routerLink: "ressourcen",
    // });
    // this.navItems.push({
    //   text: $localize`:@@PlanungAPI_SubModule_TaskStates:Task States`,
    //   routerLink: "aufgaben-status",
    // });
  }
}
